import styled from 'styled-components'

//import Black from './GeneralStyle'

export const Black = styled.p `
  margin: 0px;
  color: black;
  font-weight: ${props => props.fontWeight};
  font-size: ${props => props.fontSize};
  display: ${props => props.display};
`
Black.defaultProps = {
    fontWeight: "normal",
    fontSize: "100%",
    display: "block",
}

export const Disclaimer = Black.extend `
  font-size: 8px;
`


// WEBPACK FOOTER //
// /src/components/DataPrivDisclaimerStyle.js